import { Dimensions, Platform, StyleSheet } from 'react-native'
import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  wrapperContainer: theme => ({
    backgroundColor: theme.colors.tutorialBackgroundColor,
    flex: 0,
  }),
  container: theme => ({
    backgroundColor: theme.colors.tintColor,
    flex: 1,
  }),
  lottieContainer: theme => ({
    flex: 1,
    backgroundColor: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 'f2f2f2' : theme.colors.tutorialBackgroundColor,
    maxHeight: '60%'
  }),
  contentContainer: theme => ({
    backgroundColor: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 'f2f2f2' : theme.colors.tintColor,
    paddingHorizontal: 16.5,
    paddingVertical: 33.3,
    height: 240
  }),
  carouselContainer: {
    flex: 0,
    height: 240,
  },
  cardCarouselStyle: {
    justifyContent: 'flex-start',
    height: '100%',
  },
  stepTitleText: {
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 29.1,
    lineHeight: 37.4,
    textAlign: 'center',
  },
  stepDescriptionText: {
    textAlign: 'center',
    fontSize: 18.7,
    marginTop: 8.6,
    lineHeight: 25,
  },
  paginationContainer: {
    flex: 0,
    marginTop: 16.6,
    justifyContent: 'center',
  },
  buttonsContainer: {
    marginTop: 40.5,
  },
  secondaryButtonStyle: theme => ({
    backgroundColor: theme.colors.tintColor,
    marginTop: 12.2,
  }),
});
